'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, Package, AlertTriangle, Shield, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const navItems = [
  { label: 'Home', href: '/user-dashboard', Icon: Home },
  { label: 'Items', href: '/user-dashboard', Icon: Package },
  { label: 'Recover', href: '/lost-mode', Icon: AlertTriangle, accent: true },
  { label: 'Vault', href: '/user-dashboard', Icon: Shield },
  { label: 'Account', href: '/user-dashboard', Icon: User },
];

export default function AppBottomNav() {
  const pathname = usePathname();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-border bottom-nav-safe lg:hidden">
      <div className="flex items-center justify-around px-2 pt-2 pb-1">
        {navItems?.map(({ label, href, Icon, accent }) => {
          const isActive =
            pathname === href ||
            (label === 'Recover' && pathname === '/lost-mode');

          return (
            <Link
              key={`bottom-nav-${label}`}
              href={href}
              className="flex flex-col items-center gap-0.5 min-w-[56px] py-1.5 px-2 rounded-xl transition-all duration-150"
            >
              <span
                className={`w-10 h-10 flex items-center justify-center rounded-full transition-all duration-150 ${
                  accent
                    ? isActive
                      ? 'bg-accent shadow-accent-glow'
                      : 'bg-accent/90'
                    : isActive
                    ? 'bg-secondary' :''
                }`}
              >
                <Icon
                  size={accent ? 20 : 18}
                  className={
                    accent
                      ? 'text-white'
                      : isActive
                      ? 'text-accent' :'text-muted-foreground'
                  }
                />
              </span>
              <span
                className={`text-[10px] font-600 transition-colors ${
                  accent
                    ? 'text-accent'
                    : isActive
                    ? 'text-accent' :'text-muted-foreground'
                }`}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}